import * as React from "react";
const SvgIcon10 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 40 40" {...props}><g transform="translate(-102 -262.33)"><circle cx={20} cy={20} r={20} transform="translate(102 262.33)" style={{
      fill: "url(#icon_10_svg__linear-gradient)"
    }} /><g transform="translate(112 274)" style={{
      stroke: "var(--accent-color,#fff)",
      strokeWidth: "1.6px",
      fill: "none"
    }}><rect width={21} height={16} rx={3} style={{
        stroke: "none"
      }} stroke="none" /><rect x={0.8} y={0.8} width={19.4} height={14.4} rx={2.2} style={{
        fill: "none"
      }} /></g><path transform="translate(113 280)" style={{
      fill: "var(--accent-color,#fff)"
    }} d="M0 0h19v2H0z" /></g></svg>;
export default SvgIcon10;